import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1235941874/src/CVCircuit/frontend/app/applying-for-jobs-in-the-uk/NewToUkPageClient.tsx");
